<script lang="ts" setup>
  defineProps<{
    published: string
  }>()
</script>

<template>
  <sup class="i"><span v-if="published == PublishedStatusEnum.Draft" class="ml-1 text-red-500 font-bold text-xs text-super">draft</span><span v-if="published == PublishedStatusEnum.Unpublished" class="ml-1 text-red-500 font-bold text-xs text-super">unpublished</span></sup>
</template>

<style>

</style>